export default __webpack_public_path__ + "static/media/thumbnail.35dbcc09.webp";